import React, { useEffect } from 'react'
import "./DraftScreen.css"
import Button from "../components/Button"
import AuthCard from "../components/AuthCard"
import { useLocation, useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLock } from "@fortawesome/free-solid-svg-icons"

export default function DraftScreen() {
  const location = useLocation()
  const navigate = useNavigate()

  const state = location.state || {}
  const { title, publish_at } = state

  useEffect(() => {
    if (!title || !publish_at) navigate("/")
  }, [title, publish_at, navigate])

  const dateFormatted = publish_at
    ? new Date(publish_at).toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })
    : ""

  if (!title || !publish_at) return null

  return (
    <AuthCard>
      <div className="draftScreen__icon">
        <FontAwesomeIcon icon={faLock} />
      </div>
      <h1>Em breve</h1>
      <h2>
        <strong>{title}</strong> ainda não está disponível. Volte no dia{" "}
        <strong>{dateFormatted}</strong> para acessar esse conteúdo.
      </h2>
      <Button onClick={() => navigate("/")} text="Voltar ao Início" />
    </AuthCard>
  )
}
